export const createSelectOptions = (options, mapper) => {
    return [
        {
            value: null,
            label: 'All',
        },
        ...options.map(mapper),
    ]
}
